// 实例存放

import { driver } from 'driver.js'
import 'driver.js/dist/driver.css'

export default driver
